import Vue from 'vue';

Vue.component('modal', {
    props: {
        event: String,
    },

    template:
    `
    <div class="pop-up" v-if="showModal" v-cloak>
        <div class="pop-up-holder">
            <div class="pop-up__container">
                <div class="pop-up__title-holder">
                <div class="body-title pop-up__title"><slot name="title"></slot></div>
                    <slot name="content"></slot>
                </div>

                <div class="pop-up__cta-holder" v-if="handler">
                    <div class="cta-text pop-up__cta" @click.prevent="close">
                    {{ cancelText }}
                    </div>
                    <div class="cta-text pop-up__cta pop-up__cta--primary" @click.prevent="confirmAction">
                    OK
                    </div>
                </div>

                <div class="pop-up__cta-holder" v-else>
                    <div class="cta-text pop-up__cta" @click.prevent="close">{{ cancelText }}</div>
                </div>
            </div>
        </div>
    </div>
    `,

    data() {
        return {
            showModal: false,
            handler: null,
            cancelText: 'Cancel',
        };
    },

    mounted() {
        this.$modals.$on(`show-modal:${this.event}`, this.open);
        if (window.appLocale === 'nl') {
            this.cancelText = 'Annuleren';
        }
    },

    methods: {
        open(handler) {
            this.handler = handler;
            this.showModal = true;
        },

        close() {
            this.showModal = false;
            this.handler = null;
        },

        confirmAction() {
            if (this.handler) {
                this.handler();
            }

            this.close();
        },
    },
});
